import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';

/** Lê `?id=` da query string como corporate account id (rotas de calculadoras externas). */
@Injectable({ providedIn: 'root' })
export class CorporateAccountIdQueryResolver implements Resolve<number | null> {
  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<number | null> {
    const id = route.queryParamMap.get('id');
    if (id) return of(Number(id));
    return of(null);
  }
}
